<template>
  <section id="terms" class="termscondition">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>Terms & Conditions</h2>
      </div>
      <div class="terms">
        <p>WinFin is a service of Wintel Limited, one of the largest ethnic telecommunication providers in the
          Bangladesh.The entity you are contracting with is: Wintel Limited, House No- 25, Suite- D5, Road No- 47,
          Gulshan-2,
          Dhaka- 1212.
          In the Terms and Conditions these entities are individually and collectively referred as “WinFin”, ”we” or
          “us”.
        </p>
        <h3>General Terms of Use</h3>
        <p>By visiting and shopping at “WinFin” you accept these Terms and Conditions.</p>
        <p>WinFin's objective is to provide the highest quality services at the best rates on the market. The use of
          this website is expressly conditioned on your acceptance of all terms and conditions stated herein and any
          other place on this website. DO NOT USE THIS WEBSITE if you do not accept all the terms and conditions stated
          herein and at other places (including but not limited to: Frequently Asked Questions, Privacy Policy) on this
          website.</p>
        <p>By using WinFin's services the user accepts the rates, terms and conditions identified on this website.
          WinFin may change or modify the Terms from time to time without notice other then posting amended Terms on
          this Website. WinFin reserves the right to change, modify or discontinue, temporarily or permanently, the
          Website (or any portion thereof), including any and all content contained on the Website, at any time without
          notice. You agree that WinFin shall not be liable to you or to any third party for any modification,
          suspension or discontinuance of the Website.</p>
        <p>Whenever you provide us information on our Website, you agree to: (a) provide true, accurate, current and
          complete information and (b) maintain and promptly update such information to keep it true, accurate, current
          and complete. If you provide any information that is, or we have reasonable grounds to suspect that it is,
          untrue, inaccurate, not current or incomplete, WinFin may without notice suspend or terminate your access to
          our Website and refuse any and all current or future use of our Website (or any portion thereof). Please
          select a password that would not be obvious to someone trying to guess your password, and change it regularly
          as an added precaution. Furthermore we recommend you use a different password from the email account as an
          additional security measure. You are responsible for maintaining the confidentiality of the password and
          account, and you are fully responsible for all activities that occur under your password or account
          identification. You should make every effort to safeguard your account data. WinFin is not responsible for
          lost or stolen account data or unauthorized use. You agree to immediately notify WinFin of any unauthorized
          use of your password or account or any other breach of security.</p>
        <p>Credit/debit card fraud is a criminal offense. At WinFin we use automated and manual systems to confirm
          proper credit card authorization, including having WinFin representatives call persons who have signed up for
          WinFin services. We also track every transaction. Information related to fraudulent transactions, including
          but not limited to IP addresses, detailed transaction records and email addresses is collected. The
          information will be provided to appropriate law enforcement officials consistent with applicable law when
          required to assist in the prosecution of any persons attempting to commit fraud on WinFin websites.</p>
        <p>WinFin is the sole owner of the information collected on this website. We will not sell, share, or rent this
          information to a third party for marketing or any other purposes. We collect, retain, and use only the
          information that is necessary for you to administrate your WinFin account. Therefore, it is required for you
          to provide certain information upon using portions of our websites. Such information includes your name
          (either your name, company, or organizations name), address, phone number, email address, and other
          information gathered through the applicable process.</p>
        <p>WinFin is the sole owner of the information collected on this website. We will not sell, share, or rent this
          information to a third party for marketing or any other purposes. We collect, retain, and use only the
          information that is necessary for you to administrate your WinFin account. Therefore, it is required for you
          to provide certain information upon using portions of our websites. Such information includes your name
          (either your name, company, or organizations name), address, phone number, email address, and other
          information gathered through the applicable process.</p>
        <p>WinFin is committed to customer satisfaction and offers 100% money back guarantee. WinFin will refund the
          amount for any unused product to any customer who is dissatisfied with its services. The refund policy applies
          only for claims received by WinFin within 60 days since purchase date. Any promotion or discount applied to an
          order for which a refund is provided will be deducted from the amount of the refund.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Terms"
}
</script>

<style scoped>
.termscondition {
  margin-top: 40px;
}
.terms p{
  text-align: justify;
}
</style>